import React from 'react'
import Link from '../../utilities/link'
import Img from 'gatsby-image'
import Modal from './modal'

const StylishLinks = props => (
  <div
    className={`text-center py-24 is-relative ${props.isGradient}`}
  >
    {props.fluid && (
      <Img
        fluid={props.fluid}
        style={{
          position: 'absolute',
          overflow: 'hidden',
        }}
        imgStyle={{
          width: '100%',
          height: '100%',
          opacity: '0.9',
        }}
        className="image-wrapper-height-auto"
        alt={props.alt}
      />
    )}

    {props.animatedIllustration && (
      <div
        style={{
          position: 'absolute',
          zIndex: 1,
          overflow: 'hidden',
          bottom: 0,
          top: 0,
          height: '100%',
          width: '100%',
        }}
      >
        {props.animatedIllustration}
      </div>
    )}

    <div className="container" style={{ zIndex: 20 }}>
      <div className="columns is-centered is-multiline">
        {props.linkOneTitle && (
          <div className="column is-4 has-text-centered">
            <div
              className="content bordered-noshadow has-text-centered"
              style={{
                backgroundColor: 'rgba(255,255,255,1)',
                width: '100%',
                height: '100%',
              }}
            >
              <div
                className="title is-4"
                style={{
                  borderBottom: '1px solid #35b775',
                  paddingBottom: '20px',
                }}
              >
                {props.linkOneTitle}
              </div>
              <p style={{ color: '#363636' }}>{props.linkOneText}</p>

              {props.to1 && (
                <Link
                  to={props.to1}
                  className="button is-success"
                  style={{ marginTop: '20px' }}
                >
                  {props.linkOne}
                </Link>
              )}
              <div style={{ marginTop: '35px' }}>
                {props.component && (
                  <Modal
                    component={props.component}
                    buttonLabel={props.buttonLabel}
                    buttonClass={props.buttonClass}
                  />
                )}
              </div>
            </div>
          </div>
        )}
        {props.linkTwoTitle && (
          <div className="column is-4 has-text-centered">
            <div
              className="content bordered-noshadow has-text-centered"
              style={{
                backgroundColor: 'rgba(255,255,255,1)',
                width: '100%',
                height: '100%',
              }}
            >
              <div
                className="title is-4"
                style={{
                  borderBottom: '1px solid #35b775',
                  paddingBottom: '20px',
                }}
              >
                {props.linkTwoTitle}
              </div>
              <p style={{ color: '#363636' }}>{props.linkTwoText}</p>

              {props.to2 && (
                <a href={props.to2}
                  className="button is-success"
                  style={{ marginTop: '20px' }}
                  target="_blank" 
                  rel="noopener noreferrer"
                >
                  {props.linkTwo}
                </a>
              )}
              {props.to2internal && (
                <Link
                  to={props.to2internal}
                  className="button is-success"
                  style={{ marginTop: '20px' }}
                >
                  {props.linkTwo}
                </Link>
              )}
            </div>
          </div>
        )}
        {props.linkThreeTitle && (
          <div className="column is-4 has-text-centered">
            <div
              className="content bordered-noshadow has-text-centered"
              style={{
                backgroundColor: 'rgba(255,255,255,1)',
                width: '100%',
                height: '100%',
              }}
            >
              <div
                className="title is-4"
                style={{
                  borderBottom: '1px solid #35b775',
                  paddingBottom: '20px',
                }}
              >
                {props.linkThreeTitle}
              </div>
              <p style={{ color: '#363636' }}>{props.linkThreeText}</p>

              {props.to && (
                <Link
                  to=""
                  className="button is-success"
                  style={{ marginTop: '20px' }}
                >
                  {props.linkThree}
                </Link>
              )}
            </div>
          </div>
        )}
        {props.mainLinkText && (
          <div className="column is-12">
            <Link className="button is-dark is-medium" to={props.mainLink}>
              {props.mainLinkText}
            </Link>
          </div>
        )}
      </div>
    </div>
  </div>
)

export default StylishLinks
